import React, { memo } from 'react';
import classNames from 'classnames';

import { links as defaultLinks } from 'constants/specialistShopsLinks';

import SpecialistShopLink from './SpecialistShopLink';

import styles from './SpecialistShopsLinks.scss';

const SpecialistShopsLinks = memo(() => (
  <div className={classNames(styles.wrapper, styles.minusLeft)} data-testid="specialist-shop-links">
    {defaultLinks.map(link => (
      <SpecialistShopLink link={link} key={`specialistShops-desktop-${link.name}-link`} />
    ))}
  </div>
));

SpecialistShopsLinks.displayName = 'SpecialistShopsLinks';

export default SpecialistShopsLinks;
